import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import {
   AbstractControl,
   UntypedFormBuilder,
   UntypedFormGroup,
   ValidationErrors,
   ValidatorFn,
   Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { ExtensionChipInputOption } from 'src/app/common-components/entity-select/extension/chip-input/extension-phone-number.model';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { ExtensionDetailView } from '../../extension-details/models/extension-detail-view.model';
import { ExtensionDetailFormService } from '../../extension-details/services/extension-detail-form.service';
import { AddFindMeFollowMeStepFormData } from '../../extension-details/views/extension-find-me-follow-me-sections/models/extension-find-me-follow-me-step.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [ExtensionDetailFormService],
    selector: 'ndt-add-find-me-follow-me-step',
    styleUrls: ['./add-find-me-follow-me-step.component.scss'],
    templateUrl: './add-find-me-follow-me-step.component.html',
    standalone: false
})
export class AddFindMeFollowMeStepComponent implements FormComponent {
   callState: Observable<CallState>;

   form: UntypedFormGroup;

   extension: ExtensionDetailView | null;

   title: string;

   constructor(
      private fb: UntypedFormBuilder,
      public dialogRef: MatDialogRef<AddFindMeFollowMeStepComponent>,
      public dialogService: LcsDialogService,
      @Inject(MAT_DIALOG_DATA)
      public data: {
         extension: ExtensionDetailView | null;
         findMeFollowMeStepFormData: AddFindMeFollowMeStepFormData | null;
      }
   ) {
      this.form = this.fb.group({
         fmFmStepId: fb.control(data.findMeFollowMeStepFormData?.fmFmStepId ?? null),
         sequence: fb.control(data.findMeFollowMeStepFormData?.sequence ?? null),
         timeout: fb.control(data.findMeFollowMeStepFormData?.timeout ?? null, [
            Validators.required,
            Validators.pattern(/^[0-9]*$/),
            Validators.min(1),
            Validators.max(50),
         ]),
         extensionsOrPhoneNumbersToDial: fb.control(
            data.findMeFollowMeStepFormData?.extensionsOrPhoneNumbersToDial,
            AtLeastOneNumberToDial()
         ),
      });
      data.findMeFollowMeStepFormData
         ? (this.title = 'Edit Find Me/Follow Me Step')
         : (this.title = 'Add Find Me/Follow Me Step');
      this.extension = data.extension;
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.dialogRef.close(this.form.value);
      }
   }
}

function AtLeastOneNumberToDial(): ValidatorFn {
   return (c: AbstractControl<ExtensionChipInputOption[] | undefined>): ValidationErrors | null => {
      if (c.value && c.value.filter((v) => !v.isDeleted).length > 0) {
         return null;
      }
      return { required: true };
   };
}
